import { supabase } from './supabase';

export type MediaKind = 'youtube' | 'podcast' | 'rumble';

/**
 * Ask the server to refresh a creator's media card (latest YouTube video,
 * latest Rumble video, latest podcast episode) and get the card's row back.
 *
 * The browser never writes these caches: refresh-media-cache fetches from the
 * creator's own configured handle or feed and rate-limits itself, so calling
 * it on every page view is fine. Resolves to the card's current row (fresh, or
 * as it was if a refresh isn't due or failed), or null when there is none.
 */
export async function refreshMediaCache<T = Record<string, any>>(talentId: string, kind: MediaKind): Promise<T | null> {
  try {
    const { data, error } = await supabase.functions.invoke('refresh-media-cache', {
      body: { talent_id: talentId, kind },
    });
    if (error) return null;
    return ((data as { cache?: T } | null)?.cache ?? null) as T | null;
  } catch {
    return null;
  }
}
